import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateBlockCustomFieldValueV3 = OpalApi<
  'CreateBlockCustomFieldValueV3',
  201
>

export const createBlockCustomFieldValue: CreateBlockCustomFieldValueV3 =
  async (args = {}) => {
    const url = new URL(
      'loupe/v3/block_custom_field_values',
      window.location.origin
    )

    return HttpClient()
      .post(url.toString(), args.requestBody)
      .then((res) => res.data)
  }
